/**
 * Refus d'accès lié au statut du compte ou de l'organisation (#177, API
 * `common/access/access-status.ts`). Le code arrive en tête du message de
 * l'erreur GraphQL ; c'est la seule chose que la config de l'API transmet.
 */
export type AccessRefusal = 'ACCOUNT_DISABLED' | 'ORGANIZATION_SUSPENDED'

const REFUSALS: AccessRefusal[] = ['ACCOUNT_DISABLED', 'ORGANIZATION_SUSPENDED']

/** Paramètre d'URL qui porte le motif jusqu'à l'écran de login. */
export const REFUSAL_PARAM = 'refused'

export const REFUSAL_MESSAGE_KEYS: Record<AccessRefusal, string> = {
  ACCOUNT_DISABLED: 'access.refused.accountDisabled',
  ORGANIZATION_SUSPENDED: 'access.refused.organizationSuspended',
}

/** Le motif porté par `value` (un message, ou un paramètre d'URL), ou null. */
export function refusalIn(value: string | null | undefined): AccessRefusal | null {
  if (!value) return null
  return REFUSALS.find(code => value.includes(code)) ?? null
}

/**
 * Le motif d'une erreur Apollo ou JS, ou null. Lit le message de l'erreur et,
 * pour une erreur GraphQL combinée, celui de chacune de ses erreurs.
 */
export function accessRefusalOf(error: unknown): AccessRefusal | null {
  const messages = [
    error instanceof Error ? error.message : '',
    ...((error as { errors?: { message?: string }[] } | null)?.errors ?? []).map(err => err.message ?? ''),
  ]
  for (const message of messages) {
    const refusal = refusalIn(message)
    if (refusal) return refusal
  }
  return null
}
